import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ISiteState } from '@shared/types/site';

export const selectSitesFeature = createFeatureSelector<Readonly<ISiteState>>('sites');

export const selectSiteState = createSelector(selectSitesFeature, (state) => state);

export const selectAvailableSites = createSelector(selectSitesFeature, (state) => ({ sites: state.sites }));

export const selectSitesAndSelectedSites = createSelector(selectSitesFeature, (state) => ({
    sites: state.sites,
    selectedSites: state.selectedSites,
}));

export const selectSelectedSites = createSelector(selectSitesFeature, (state) => state.selectedSites);

export const selectSitesAndSelectedSite = createSelector(selectSitesFeature, (state) => ({
    sites: state.sites,
    selectedSite: state.selectedSite,
}));

export const selectActiveSiteAndSites = createSelector(selectSitesFeature, (state) => ({
    selectedSite: state.selectedSite,
    selectedSites: state.selectedSites,
}));

export const selectEnablePicker = createSelector(selectSitesFeature, (state) => state.enablePicker);

export const selectIframePostMessageResult = createSelector(selectSitesFeature, (state) => ({
    iframePostMessageResult: state.iframePostMessageResult,
}));

export const selectXCATSiteSubscriptionState = createSelector(
    selectSitesFeature,
    (state) => state.XCATSubscriptionStoreSelected,
);
